import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "scrollbar absolute-full-size p-2" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center mt-4 mt-2"
}

import InfiniteScrollContainer from "~/core-ui/vue/InfiniteScrollContainer.vue";
import {computed, getCurrentInstance, onMounted, watch} from "vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import DialogCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dialogsTab/DialogCard.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import ArrayHelper from "~/ts/library/ArrayHelper";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import MyFilter from "~/cabinet/vue/interface/filter/MyFilter.vue";
import Delay from "~/ts/library/Delay";
import {StorageInstance} from "~/ts/library/storage/StorageFactory";

import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import OperatorApplicationDialogOpenApiModel = OperatorApplicationApi.OperatorApplicationDialogOpenApiModel;

import {defineComponent, ref} from 'vue';
import Dictionary from "~/ts/library/Dictionary";
import {__} from "~/ts/library/Translate";

import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";

let filtersDataStorage = ref<Dictionary<ReactiveRequest<OperatorApplicationApi.OperatorMessageGetDialogsFiltersResultOpenApiModel>>>({});

const __default__ = defineComponent({
    name: "DialogsTab"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {}
  },
  setup(__props: any) {

let props = __props;


let isMounted = ref(false);
let instance = getCurrentInstance().proxy;

onMounted(() => isMounted.value = true);

let filtersModel = computed({
    get: () => {
        return StorageInstance.get(`dialogFilters_${props.userdata.siteId}`) ?? {};
    },
    set: (value: any) => {
        StorageInstance.set(`dialogFilters_${props.userdata.siteId}`, value)
    }
});

let dialogIdsByFilters = ref<number[]>([]);

let dialogIds = computed(() => {
    let filters = filtersModel.value;
    if (ObjectHelper.hasKeys(filters)) {
        return dialogIdsByFilters.value;
    }
    return ClientUserdataStore.getDialogsIdsByUsername(props.userdata.username)
});

let dialogsDictionary = computed(() => ClientUserdataStore.getDialogsByUsername(props.userdata.username));

watch(dialogsDictionary, async () => {
    if (!ObjectHelper.hasKeys(dialogsDictionary.value)) {
        for (let dialogId of await loadMethod()) {
            dialogIds.value.push(dialogId);
        }
    }
});

let dialogs = computed<OperatorApplicationDialogOpenApiModel[]>(() => {
    return ArrayHelper.unique(dialogIds.value)
        .sort((a, b) => a > b ? -1 : 1)
        .map(dialogId => dialogsDictionary.value[dialogId])
        .filter(dialog => !!dialog);
});

let site = computed(() => OperatorAccountStore.sitesDictionary.value[props.userdata.siteId]);

let loading = ref(false);

async function loadMethod(): Promise<number[]> {
    loading.value = true;
    let p: OperatorApplicationApi.OperatorMessageGetDialogsOpenApiModel = {
        username: props.userdata.username,
        count: 15,
        firstDialogId: dialogs.value[dialogs.value.length - 1]?.id,
        filters: filtersModel.value ? JSON.stringify(filtersModel.value) : undefined
    };
    let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorMessageGetDialogsResultOpenApiModel>({
        url: "/message/getDialogs",
        p,
        silent: true,
        silentError: true
    })).send();
    loading.value = false;
    if (!result.showMessageOnError()) {
        for (let dialog of result.data.dialogs) {
            dialogsDictionary.value[dialog.id] = dialog;
        }
        return result.data.dialogs.map(dialog => dialog.id).sort((a, b) => a > b ? -1 : 1);
    } else {
        return [];
    }
}

let filtersRequest = computed(() => {
    let siteId = props.userdata.siteId;
    let request = filtersDataStorage.value[siteId];
    if (!request) {
        let p: OperatorApplicationApi.OperatorMessageGetDialogsFiltersOpenApiModel = {
            siteId
        };
        request = filtersDataStorage.value[siteId] = new ReactiveRequest(new OperatorApiRequest({
            url: "/message/getDialogsFilters",
            p
        })).setErrorCallback(async () => {
            await Delay.make(5000);
            request.make();
        })
    }
    return request;
});

let filters = computed(() => {
    let request = filtersRequest.value;
    if (request.isSuccess && request.data) {
        return JSON.parse(request.data.filters);
    }
    return null;
});

let refreshKey = ref<number>();

let scrollContainerKey = computed(() => {
    return JSON.stringify(filtersModel.value) + refreshKey.value;
})

function onFiltersInput() {
    dialogIdsByFilters.value = [];
}

function reload() {
    onFiltersInput();
    refreshKey.value = Date.now();
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReactiveRequestLoader, {
      class: _normalizeClass(["mt-2", _unref(filters) ? null : 'text-center']),
      request: _unref(filtersRequest),
      "big-loader": false
    }, {
      default: _withCtx(() => [
        (_unref(filters))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(MyFilter, {
                "filters-data": _unref(filters),
                modelValue: _unref(filtersModel),
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => (_isRef(filtersModel) ? (filtersModel).value = $event : filtersModel = $event)),
                  onFiltersInput
                ],
                "dropdown-fixed": "",
                "hide-add-button": ""
              }, null, 8, ["filters-data", "modelValue"]),
              (_unref(ObjectHelper).hasKeys(_unref(filtersModel)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_el_button, {
                      class: "w-100 d-block",
                      type: "primary",
                      onClick: reload
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(__)("Обновить")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["request", "class"]),
    (_unref(isMounted))
      ? (_openBlock(), _createBlock(InfiniteScrollContainer, {
          "load-method": loadMethod,
          key: _unref(scrollContainerKey),
          "scroll-container": _unref(instance).$el,
          items: _unref(dialogIds),
          "scroll-direction": "bottom"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogs), (dialog) => {
              return (_openBlock(), _createBlock(DialogCard, {
                key: dialog.id,
                class: "dialog mt-2",
                userdata: __props.userdata,
                dialog: dialog,
                site: _unref(site),
                "is-ai-available-by-license": _unref(site)?.isCopilotAvailableByTarif
              }, null, 8, ["userdata", "dialog", "site", "is-ai-available-by-license"]))
            }), 128)),
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(MyLoader)
                ]))
              : (!_unref(dialogs).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("h4", null, "Диалоги не найдены", -1)
                  ]))]))
                : _createCommentVNode("", true),
            _cache[2] || (_cache[2] = _createElementVNode("div", null, " ", -1))
          ]),
          _: 1
        }, 8, ["scroll-container", "items"]))
      : _createCommentVNode("", true)
  ]))
}
}

})